/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';

import InnerBanner from './innerBanner';
import AboutTeamComponent from './aboutTeam';
import ContactSection from './contactSection';
import OpportunitiesBox from './opportunitiesBox';


const Career = ({ content, scrollToTag }) => {
  return (<div className='career-pg'>
    {/* inner-banner section start */ }
    <InnerBanner
      banner_cta_button={ content && content.banner_cta_button }
      banner_image={ content && content.banner_image }
      banner_info={ content && content.banner_info }
      banner_title={ content && content.banner_title }
      scrollToTag={ scrollToTag }
    />
    {/* inner-banner section end */ }

    {/* divider section start */ }
    <div className="divider-box" style={ { height: '3px' } }>
      <span className='line'></span>
    </div>
    {/* divider section end */ }

    {/* information section start */ }
    <AboutTeamComponent
      team_section_content={ content && content.team_section_content }
      team_section_logo={ content && content.team_section_logo }
      team_section_title={ content && content.team_section_title }
    />
    {/* information section end */ }

    {/* divider section start */ }
    <div className="divider-box" style={ { height: '3px' } }>
      <span className='line'></span>
    </div>
    {/* divider section end */ }

    {/* opportunities section start */ }
    <OpportunitiesBox
      opportunities_section_title={ content && content.opportunities_section_title }
      opportunities_section={ content && content.opportunities_section }
    />
    {/* opportunities section end */ }

    {/* information section start */ }
    <ContactSection
      contact_section_content={ content && content.contact_section_content }
      contact_section_title={ content && content.contact_section_title }
      contact_section_cta_button={ content && content.contact_section_cta_button }
    />
    {/* information section end */ }
  </div>);
};

export default Career;